import { fundCards } from "../../infrastructure/repository/company-repository";
import { showSuccessMessage } from "../commons/show-success-message";
import { showErrorMessage } from "../commons/show-error-message";
import { hideModal } from "../commons/hide-modal";
import { logError, addContextLog } from "../../infrastructure/log";
import { translate } from "../../infrastructure/translate/localization";
import { getAllowance } from "../../infrastructure/allowance-config-repository";

export function adaptEmployees(customEmployees, ids) {
  return ids.map((id) => ({
    employeeId: id,
    subsidies: [
      {
        category: "meal-benefit",
        days: customEmployees[id].mealDays,
        amount: {
          amountInCents: Math.round(customEmployees[id].mealAmount * 100),
          currency: "EUR",
        },
      },
      {
        category: "transport-benefit",
        days: 1,
        amount: {
          amountInCents: Math.round(customEmployees[id].transportAmount * 100),
          currency: "EUR",
        },
      },
      {
        category: "nursery-benefit",
        days: 1,
        amount: {
          amountInCents: Math.round(customEmployees[id].nurseryAmount * 100),
          currency: "EUR",
        },
      },
    ],
  }));
}

export async function performTopUp(modelId) {
  try {
    const { employeesItems, employeeIds } = getAllowance();
    const employees = adaptEmployees(employeesItems, employeeIds);

    await fundCards({ employees, modelId });
    addContextLog("info", "adaptEmployees", "request", {
      employees: employeeIds,
      modelId,
    });

    showSuccessMessage(translate("subsidy-section.allowance-delivery-success"));
    hideModal();
  } catch (e) {
    logError(e, `Error to performTopUp`);
    showErrorMessage(translate("common-messages.basic-error-message"), true);
  }
}
